export class GenericDialogData {
  public title: string = '';
  public content: string = '';
  public buttons: string[] = [];
  public buttonStyles: string[] = [];
  public icon: string = '';
  public displayBackLink?: boolean;
  constructor() {/**/}
}
